import { render, staticRenderFns } from "./SpouseRiderWidget.vue?vue&type=template&id=099fd3ea&scoped=true"
import script from "./SpouseRiderWidget.vue?vue&type=script&lang=js"
export * from "./SpouseRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./SpouseRiderWidget.vue?vue&type=style&index=0&id=099fd3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fd3ea",
  null
  
)

export default component.exports